//Global keys
let locales = {
    "announcementsContractManage_menu": "Contrato de aceptación de cliente",
};

export default locales;